import React, { useEffect, useRef } from "react";
import { SketchPicker } from "react-color";
import { Button } from "reactstrap";

export default function ColorPickerPopover({ color, onChange, onApply, position, onClose }) {
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return (
    <div
      ref={pickerRef}
      style={{
        position: "absolute",
        top: position.top,
        left: position.left,
        zIndex: 9999,
        background: "#fff",
        boxShadow: "0 0 15px rgba(0,0,0,0.2)",
        borderRadius: 8,
        padding: 10
      }}
    >
      <SketchPicker
        color={color}
        onChange={(color) => onChange(color.hex)}
        disableAlpha
      />
      <div className="text-end mt-2">
        <Button size="sm" color="primary" onClick={onApply}>
          Apply
        </Button>
      </div>
    </div>
  );
}
